import React,{useState} from "react";

import { PaymentElement,useStripe,useElements } from "@stripe/react-stripe-js";
import { Button,Box } from "@mui/material";
const PaymentForm=()=>{
const stripe=useStripe()
const elements=useElements()
const [loading,setLoading]=useState(false)
const [message,setMessage]=useState("")
let handleSubmit= async(e)=>{
e.preventDefault()
setLoading(true)
if(!stripe||!elements){
    return
}
const paymentFlow = localStorage.getItem("paymentFlow") || (localStorage.getItem("authtoken") ? "subscription" : "signup")
const returnUrl = paymentFlow === "signup"
    ? `${process.env.REACT_APP_URL}payment-processing?flow=signup`
    : `${process.env.REACT_APP_URL}products?flow=subscription`
const {error}=await stripe.confirmPayment({
    elements,
    confirmParams: {
        return_url: returnUrl
      },
})
if (error){
    setMessage(error.message||"Something went wrong")
}
// else{
//     CustomAxios.post('active_plan/',{user_id:JSON.parse(localStorage.getItem('user'))?.user_id||id,order_id:elements?._commonOptions.clientSecret.id,package:JSON.parse(localStorage.getItem('package'))}).then(res=>{
        
//         if (res.status==200){
//             localStorage.setItem("authtoken", res.data.access_token)
//             localStorage.setItem("refreshToken", res.data.refresh_token)
//             navigate("/products")
//         }
//         else{
//             navigate("/login")
//         }
//     }).catch(err=>{console.log(err)})
// }
setLoading(false)
}

return <Box sx={{display:"flex",flexDirection:"column",gap:"24px"}}>
    <PaymentElement/> 
    <Button variant="contained" sx={{alignSelf:"flex-end"}} disabled={!stripe||loading} onClick={(e)=>handleSubmit(e)} >Submit</Button>
 
</Box>

}
export default PaymentForm
